import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import styled from 'styled-components';
import Link from '@nubank/nuds-web/components/Link/Link';

import Image from '@nubank/www-latam-commons/components/Image/Image';

const StyledImage = styled(Image)`
  margin-top: -64px;

  @media (width >= 768px) {
    width: 120px;
    height: 100%;
    margin-top: -84px;
  }
`;

const Title = styled(Typography)`
  font-size: 30px;
  font-weight: 500;
  line-height: 36px;
  letter-spacing: -0.03em;
  text-align: left;

  span {
    background: linear-gradient(99.92deg, #9F2DEB 18.57%, #6200A3 71.77%);
    /* stylelint-disable property-no-vendor-prefix, property-no-unknown */
    -webkit-text-fill-color: transparent;
    -webkit-background-clip: text;
    background-clip: text;
  }

  @media (width >= 768px) {
    text-align: center;
    font-size: 44px;
    line-height: 48.4px;
  }
`;

function FAQ() {
  return (
    <Box
      tag="section"
      display="flex"
      justifyContent="center"
      width="100%"
      marginTop={{ xs: '80px', md: '120px' }}
      marginBottom="60px"
    >

      <Box
        width="100%"
        backgroundColor="#F8F8FA"
        borderRadius="12px"
        maxWidth={{ xs: '328px', md: '602px', lg: '802px' }}
        marginHorizontal={{ xs: '24px' }}
        paddingTop="24px"
        paddingBottom="24px"
        paddingHorizontal="24px"
      >
        <Box
          display={{ xs: 'block', md: 'flex' }}
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          marginBottom={{ xs: '8px', md: '20px' }}
        >

          <StyledImage
            src="atencion/help-icon.svg"
            alt="Icono de ayuda"
            height="100px"
            width="auto"
            webp={false}
          />

          <Title
            marginTop="40px"
            variant="heading4"
            whiteSpace="pre-line"
            marginBottom="50px"
            display={{ xs: 'none', md: 'block' }}
          >
            {'Resuelve más dudas en \n'}
            <span>
              preguntas frecuentes
            </span>
          </Title>

          <Title
            marginTop="30px"
            variant="heading4"
            whiteSpace="pre-line"
            marginBottom="40px"
            display={{ xs: 'block', md: 'none' }}
          >
            {'Resuelve más \n dudas en '}
            <span>
              preguntas frecuentes
            </span>
          </Title>

          <Link href="/ayuda" variant="action">
            Conoce más
          </Link>
        </Box>

      </Box>
    </Box>
  );
}

export default FAQ;
